import React, { useContext, useEffect } from "react";
import { editProfileAPI, getProfileAPI } from "../../APIs/API";
import { useForm } from "react-hook-form";
import { MyContext } from "../../MyContext/MyProvider";

const EditprofileComp = () => {
  const { setIsLoading } = useContext(MyContext);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const res = await getProfileAPI();
        if (res) {
          setIsLoading(false);
          setValue("email", res.email);
          setValue("firstname", res.firstname);
          setValue("lastname", res.lastname);
          setValue("address", res.address);
          setValue("contact_number", res.contact_number);
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    };
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    try {
      const res = await editProfileAPI(data);
      console.log(res);
    } catch (error) {
      console.error("Submit error: ", error);
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="edit-profile-main d-flex flex-column gap-5"
      >
        <div className="edit-container d-flex gap-85 ">
          {/* <div className="edit-profile-inner d-flex flex-column gap-3">
            <h5>Type</h5>
            <input
              type="text"
              placeholder="Type..."
              className="modal-input "
            ></input>
          </div> */}
          <div className="edit-profile-inner d-flex flex-column gap-3">
            <h5>First Name</h5>
            <input
              {...register("firstname", {
                required: "First name is required",
                maxLength: {
                  value: 20,
                  message: "Must not be more than 20 characters",
                },
              })}
              inputMode="text"
              type="text"
              placeholder="First Name"
              className="modal-input "
            />{" "}
            {errors.firstname && (
              <span className="error">{errors.firstname.message}</span>
            )}
          </div>
          <div className="edit-profile-inner d-flex flex-column gap-3">
            <h5>Last Name</h5>
            <input
              {...register("lastname", {
                required: "Last name is required",
                maxLength: {
                  value: 20,
                  message: "Must not be more than 20 characters",
                },
              })}
              inputMode="text"
              type="text"
              placeholder="Last Name"
              className="modal-input "
            />
            {errors.lastname && (
              <span className="error">{errors.lastname.message}</span>
            )}
          </div>
        </div>
        <div className="edit-container d-flex  gap-85 ">
          {/* <div className="edit-profile-inner d-flex flex-column gap-3">
            <h5>Address</h5>
            <input
              {...register("address", {
                required: "address is required",
                maxLength: {
                  value: 100,
                  message: "Must not be more than 50 characters",
                },
              })}
              inputMode="text"
              type="text"
              placeholder="Address"
              className="modal-input "
            />
            {errors.address && (
              <span className="error">{errors.address.message}</span>
            )}
          </div> */}
        </div>
        <div className="edit-container d-flex  gap-85 ">
          <div className="edit-profile-inner d-flex flex-column gap-3">
            <h5>Email Address</h5>
            <input
              {...register("email", {
                required: "Email is required",
                maxLength: {
                  value: 30,
                  message: "Must not be more than 30 characters",
                },
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/,
                  message: "Invalid email address",
                },
              })}
              inputMode="email"
              disabled
              type="email"
              placeholder="abc@gmail.com"
              className="modal-input forbidden"
            />
            {errors.email && (
              <span className="error">{errors.email.message}</span>
            )}
          </div>
          <div className="edit-profile-inner d-flex flex-column gap-3">
            <h5>Contact Number</h5>
            <input
              {...register("contact_number", {
                required: "Contact number is required",
                maxLength: {
                  value: 20,
                  message: "Must not be more than 20 characters",
                },
                pattern: {
                  value: /^[0-9]+$/,
                  message: "Invalid contact number, must only be digits",
                },
              })}
              inputMode="numeric"
              type="number"
              placeholder="Contact Number"
              className="modal-input "
            />
            {errors.contact_number && (
              <span className="error">{errors.contact_number.message}</span>
            )}
          </div>
        </div>
        <div className="setting-bottom h-center">
          <button type="submit" className="setting-button">
            Confirm
          </button>
        </div>
      </form>
    </>
  );
};

export default EditprofileComp;
